import { render, staticRenderFns } from "./TransactionInfo.vue?vue&type=template&id=8e84b47c&"
import script from "./TransactionInfo.vue?vue&type=script&lang=js&"
export * from "./TransactionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports